import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Logo from "../../../images/slogo.png";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ToastContainer, toast } from "react-toastify";

const AddSprintDetail = () => {
  const userTemplate = {
    sprintName: "",
    startDate: "",
    SprintDetails: "",
    endDate: "",
    Status: "",
    SprintLink: "",
  };
  const [users, setUsers] = useState([userTemplate]);
  const [itemCount, setItemCount] = useState(1);

  const addUser = () => {
    if (itemCount == totalSprint) {
      toast.error(`You add Only ${totalSprint} sprint`);
    } else {
      setUsers([...users, userTemplate]);
      setItemCount(itemCount + 1);
    }
  };

  const handleChange = (e, index) => {
    const updateUser = users.map((user, i) =>
      index == i
        ? Object.assign(user, { [e.target.name]: e.target.value })
        : user
    );
    console.log(updateUser);
    setUsers(updateUser);
  };

  const location = useLocation();
  const totalSprint = location.state.id;

  console.log(itemCount, "itemCount");
  console.log(totalSprint, "totalSprint");

  let { mileStoneName, id } = useParams();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(users);
    let sprintData = sessionStorage.getItem("sprintData");

    if (sprintData) {
      sprintData = JSON.parse(sprintData);
      let milestoneExists = false;
      sprintData.map((value) => {
        if (value.milestone == mileStoneName && value.id == id) {
          value.sprints = users;
          milestoneExists = true;
        }
      });

      if (!milestoneExists) {
        sprintData.push({ mileStoneName, id, sprints: users });
      }
      sessionStorage.setItem("sprintData", JSON.stringify(sprintData));
      // sprintData.push();
    } else {
      let userData = { mileStoneName, id, sprints: users };
      sessionStorage.setItem("sprintData", JSON.stringify([userData]));
      toast.success("add sprint successfully!")
    }
  };

  return (
    <div>
      <ToastContainer />
      <div
        className="card-header"
        style={{ background: "#f1fdff", paddingBottom: "10px" }}
      >
        <div style={{ textAlign: "center", padding: "20px" }}>
          <h2>Add Sprint Details</h2>
        </div>
        <div
          style={{
            width: "70%",
            background: "white",
            margin: "0 auto",
            height: "auto",
            marginBottom: "10px",
            border: "2px solid gray",
            borderRadius: "7px",
          }}
        >
          <div style={{ width: "80%", display: "flex", margin: "0 auto" }}>
            <div
              style={{
                width: "42%",
                // border: "1px solid gray",
                height: "100px",
                marginTop: "9%",
                borderRadius: "5px",
                marginLeft: "-58px",
              }}
            >
              <img src={Logo} alt="slogo" />
            </div>
            <div style={{ width: "50%" }}></div>
          </div>
          <div
            style={{
              border: "1px solid gray",
              width: "90.4%",
              margin: "0 auto;",
              marginLeft: "52px",
              borderRadius: "5px",
              marginBottom: "64px",
              marginTop: "41px",
            }}
          >
            <div
              className="Job_button_payment"
              style={{ width: "93.5%", textAlign: "center", fontWeight: "600" }}
            >
              Sprint 1
            </div>
            <form onSubmit={handleSubmit}>
              {users.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    width: "80%",
                    margin: "0 auto",
                    paddingTop: "50px",
                  }}
                >
                  <div style={{ width: "40%" }}>
                    <div className="label_job">
                      <label for="first_name">sprintName</label>
                      <input
                        type="text"
                        style={{ height: "24px" }}
                        class="form-control_Job_Form "
                        placeholder="Sprint No"
                        required
                        name="sprintName"
                        value={item.sprintName}
                        onChange={(e) => handleChange(e, index)}
                      />
                    </div>
                    <div className="label_job">
                      <label for="first_name">Start Date</label>
                      <input
                        style={{
                          width: "338px",
                          height: "42px",
                          marginTop: "10px",
                          borderRadius: "5px",
                          border: "1px solid gray",
                        }}
                        type="text"
                        name="startDate"
                        placeholder="2022/09/09"
                        value={item.startDate}
                        onChange={(e) => handleChange(e, index)}
                      />
                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Basic example"
                      value={value}
                      onChange={(newValue) => {
                        setValue(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider> */}
                    </div>
                    <div className="label_job" style={{ marginTop: "12px" }}>
                      <label for="first_name">Sprint Details</label>
                      <textarea
                        style={{ height: "108px" }}
                        type="text"
                        class="form-control_Job_Form "
                        placeholder="Sprint Details"
                        required
                        name="SprintDetails"
                        value={item.SprintDetails}
                        onChange={(e) => handleChange(e, index)}
                      />
                    </div>
                  </div>
                  <div style={{ width: "15%" }}></div>
                  <div style={{ width: "40%" }}>
                    {/* <div className="label_job">
                      <label for="first_name">Job Work Order</label>
                      <input
                        type="text"
                        style={{ height: "24px" }}
                        class="form-control_Job_Form "
                        placeholder="Job Work Order"
                        required
                        name="jobLocation"
                        // value={jobLocation}
                        // onChange={(e) => setJobLocation(e.target.value)}
                      />
                    </div> */}
                    <div className="label_job">
                      <label for="first_name">End Date</label>
                      <input
                        style={{
                          width: "338px",
                          height: "42px",
                          marginTop: "10px",
                          borderRadius: "5px",
                          border: "1px solid gray",
                        }}
                        type="text"
                        name="endDate"
                        placeholder="2022/09/19"
                        value={item.endDate}
                        onChange={(e) => handleChange(e, index)}
                      />
                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          // label="Basic example"
                          value={value}
                          onChange={(newValue) => {
                            setValue(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider> */}
                    </div>
                    <div className="label_job" style={{ marginTop: "11px" }}>
                      <label for="first_name">Status</label>
                      <input
                        type="text"
                        style={{ height: "24px" }}
                        class="form-control_Job_Form "
                        placeholder="Status"
                        required
                        name="Status"
                        value={item.Status}
                        onChange={(e) => handleChange(e, index)}
                      />
                    </div>
                    <div className="label_job">
                      <label for="first_name">Sprint Link</label>
                      <input
                        type="text"
                        style={{ height: "24px" }}
                        class="form-control_Job_Form "
                        placeholder="Sprint Link"
                        required
                        name="SprintLink"
                        value={item.SprintLink}
                        onChange={(e) => handleChange(e, index)}
                      />
                    </div>
                  </div>
                </div>
              ))}

              <div
                style={{
                  textAlign: "center",
                  marginBottom: "46px",
                  marginTop: "84px",
                }}
              >
                <button
                  type="submit"
                  style={{
                    padding: "13px 25px",
                    marginRight: "15px",
                    color: "#588fa8",
                    background: "transparent",
                    border: "1px solid #588fa8",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                // onClick={handleSubmit}
                >
                  Save
                </button>
                <button
                  type="button"
                  style={{
                    padding: "13px 25px",
                    marginRight: "15px",
                    color: "#588fa8",
                    background: "#d6f0fd",
                    border: "1px solid #588fa8",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={addUser}
                >
                  Add Another Sprint
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSprintDetail;
